(function ($) {
    'use strict';

    var ValidationEngine = (function () {
        var self = this, base,
            field, validation, fields = [],
            firstTime = true;

        self.processFields = function (options) {

            $.each(options, function (k, v) {
                field = {};

                if (typeof (v) === 'object') {
                    field.selector = k;
                    field.enabled = v.enabled !== undefined ? v.enabled : true

                    delete v.enabled; // could be done better :(

                    self.processValidations(v);
                    self.bindValidations(field);
                    fields.push(field);
                } else {
                    console.error('ValidationEngine: ' + k + ' must be of type object. Not ' + typeof (v) + '.');
                };
            });
        };

        self.processValidations = function (validations) {
            field.validations = {};

            $.each(validations, function (k, v) {
                field.validations[k] = {};

                if (typeof (v) === 'object') {
                    $.each(v, function (key, value) {
                        field.validations[k][key] = value;
                    });
                } else {
                    field.validations[k].validator = v;
                };
            });
        };

        self.bindValidations = function (f) {
            f.$elem = $('*[name="' + f.selector + '"]', base.$elem);

            if (f.$elem.length !== 1) {
                console.error('ValidationEngine: None or multiple results for selector: "' + f.selector + '".');
            };
        };

        self.getValue = function (f) {
            var tag = self.getTagName(f);

            return tag === 'select' || tag === 'textarea'
                ? f.$elem.val()
                : tag === 'input'
                    ? f.$elem.attr('type') === 'text' || f.$elem.attr('type') === 'password' || f.$elem.attr('type') === 'date' || f.$elem.attr('type') === 'tel'
                        ? f.$elem.val()
                        : f.$elem.attr('type') === 'radio'
                            ? $('input[name=' + f.$elem.attr('name') + ']:checked').val()
                            : f.$elem.attr('type') === 'checkbox'
                                ? f.$elem.is(':checked')
                                : null
                    : null;
        };

        self.getTagName = function (f) {
            return f.$elem.prop("tagName").toLowerCase();
        };

        self.searchField = function (selector) {
            var field;

            $.each(fields, function (i, f) {
                if (f.selector === selector) {
                    field = f;

                    return false;
                };
            });

            return field;
        };

        self.validateField = function (f) {
            var result = true;

            $.each(f.validations, function (fn, opts) {
                if (fn === 'match') {
                    var matchField = self.searchField(opts.matchField);

                    if (matchField) {
                        if (typeof (opts.beforeValidation) === 'function')
                            opts.beforeValidation(f.$elem);

                        if (opts.optional) {
                            if ($.fn.validationEngine.validations.optional(self.getValue(f))) {
                                if (!$.fn.validationEngine.validations[fn]
                                    .call(self, self.getValue(f), self.getValue(matchField), opts.config)) {

                                    result = opts.validator;
                                };
                            };
                        } else {
                            if (!$.fn.validationEngine.validations[fn]
                                .call(self, self.getValue(f), self.getValue(matchField), opts.config)) {

                                result = opts.validator;
                            };
                        };
                    } else {
                        console.error('ValidationEngine: MatchField was not found for match key : "' + opts.matchField + '".');
                    };

                } else {
                    if (typeof (opts.beforeValidation) === 'function')
                        opts.beforeValidation(f.$elem);

                    if (opts.optional) {
                        if ($.fn.validationEngine.validations.optional(self.getValue(f))) {
                            if (!$.fn.validationEngine.validations[fn]
                                .call(self, self.getValue(f), opts.config)) {

                                result = opts.validator;
                            };
                        };
                    } else {
                        if (!$.fn.validationEngine.validations[fn]
                            .call(self, self.getValue(f), opts.config, f.$elem.get(0))) {

                            result = opts.validator;
                        };
                    };
                };

                if (result !== true) {
                    $.each(f.validations, function (f, o) {
                        $('.' + o.validator, base.$elem).removeClass('error');
                        if ($('.' + o.validator, base.$elem).closest('.form-row').length > 0) {
                            $('.' + o.validator, base.$elem).closest('.form-row').removeClass('with-error');
                        }
                    });

                    $('.' + result, base.$elem).addClass('error');

                    if ($('.' + result, base.$elem).closest('.form-row').length > 0) {
                        $('.' + result, base.$elem).closest('.form-row').addClass('with-error');
                    }
                    if (typeof (opts.afterValidation) === 'function')
                        opts.afterValidation(f.$elem, result);

                    return false;
                };
            });

            if (result === true) {
                $.each(f.validations, function (fn, opts) {
                    $('.' + opts.validator, base.$elem).removeClass('error');

                    if ($('.' + opts.validator, base.$elem).closest('.form-row').length > 0) {
                        $('.' + opts.validator, base.$elem).closest('.form-row').removeClass('with-error');
                    }
                    if (typeof (opts.afterValidation) === 'function')
                        opts.afterValidation(f.$elem, result);
                });
            }

            return result;
        };

        self.validateAll = function () {
            var result = true;

            $.each(fields, function (i, f) {
                if (f.enabled === false)
                    return true;

                if (self.validateField(f) !== true)
                    result = false;
            });

            return result;
        };

        return {
            init: function (options, elem) {
                base = this;

                base.$elem = $(elem);
                base.options = options;

                self.processFields(base.options);
            },

            reset: function () {
                firstTime = true;

                $.each(fields, function (i, f) {
                    $.each(f.validations, function (j, v) {
                        $('.' + v.validator, base.$elem).removeClass('error');
                        if ($('.' + v.validator, base.$elem).closest('.form-row').length > 0) {
                            $('.' + v.validator, base.$elem).closest('.form-row').removeClass('with-error');
                        }
                    });
                });
            },

            destroy: function () {
                base.$elem.removeData();

                /*
                 * TODO: FIX THIS !!!!
                 */

                base = undefined;
                self = undefined;
            },

            addField: function (options) {
                self.processFields(options);
            },

            addFields: function (options) {
                self.processFields(options);
            },

            removeField: function (f) {
                $.each(fields, function (i, item) {
                    if (item.selector === f) {
                        fields.splice(i, 1);

                        return false;
                    };
                });
            },

            removeFields: function (array) {
                $.each(array, function (i, f) {
                    base.removeField(f);
                });
            },

            validateField: function (f) {
                if (f) {
                    var field = self.searchField(f);

                    if (field) {
                        if (field.enabled)
                            self.validateField(field);
                    }
                }
            },

            enable: function (array) {
                $.each(array, function (i, key) {
                    var f = self.searchField(key);

                    if (f)
                        f.enabled = true;
                    else
                        console.error('ValidationEngine: None fields found for key: "' + key + '".');
                });
            },

            disable: function (array) {
                $.each(array, function (i, key) {
                    var f = self.searchField(key);

                    if (f) {
                        f.enabled = false;

                        $.each(f.validations, function (f, o) {
                            $('.' + o.validator, base.$elem).removeClass('error');
                            if ($('.' + o.validator, base.$elem).closest('.form-row').length > 0) {
                                $('.' + o.validator, base.$elem).closest('.form-row').removeClass('with-error');
                            }
                        });
                    } else {
                        console.error('ValidationEngine: None fields found for key: "' + key + '".');
                    };
                });
            },

            validate: function (f) {
                if (f) {
                    if (firstTime)
                        return;

                    var field = self.searchField(f);

                    if (field) {
                        if (field.enabled)
                            self.validateField(field);
                    };
                } else {
                    if (firstTime)
                        firstTime = false;

                    return self.validateAll();
                };
            }
        };
    });

    $.fn.validationEngine = function (options) {
        return this.each(function () {
            var va;

            if ($(this).data("va-init") === true) {
                return false;
            }

            $(this).data("va-init", true);

            va = new ValidationEngine();
            va.init(options, this);

            $.data(this, "validationEngine", va);
        });
    };

    $.fn.validationEngine.validations = {
        optional: function (value) {
            if ($.trim(value).length === 0)
                return false;

            return true;
        },

        required: function (value) {
            if ($.trim(value).length > 0)
                return true;

            return false;
        },

        checkboxRequired: function (value) {

            return value;
        },

        isEmail: function (value) {
            var reg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}|^$/i;

            return reg.test(value);
        },

        isNumeric: function (value) {
            var reg = /^\d+$/;

            return reg.test(value);

        },

        isAlphaNumeric: function (value) {

            return true;
        },

        match: function (value1, value2) {

            return value1 === value2;
        },

        length: function () {
            var value = arguments[0], config = arguments[1], score;

            if (config && config.limit !== 'undefined')
                return value.length === config.limit;

            return false;
        },

        maxLength: function () {
            var value = arguments[0], config = arguments[1], score;

            if (config && config.limit !== 'undefined')
                return value.length <= config.limit;

            return false;
        },

        minLength: function () {
            var value = arguments[0], config = arguments[1], score;

            if (config && config.limit !== 'undefined')
                return value.length >= config.limit;

            return false;
        },

        validIBAN: function (value) {

            if ($.trim(value).length > 0) {

                var CODE_LENGTHS = {
                    GR: 27

                    //AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
                    //CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
                    //FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
                    //HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
                    //LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
                    //MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
                    //RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
                };

                var iban = String(value).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
                    code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
                    digits;

                // check syntax and length
                if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
                    return false;
                }

                // rearrange country code and check digits, and convert chars to ints
                digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
                    return letter.charCodeAt(0) - 55;
                });

                var checksum = digits.slice(0, 2), fragment;
                for (var offset = 2; offset < digits.length; offset += 7) {
                    fragment = String(checksum) + digits.substring(offset, offset + 7);
                    checksum = parseInt(fragment, 10) % 97;
                }

                if (checksum == 1)
                    return true;
            }

            return false;
        },
        matchRegex: function () {
            var value = arguments[0], config = arguments[1];

            if (config && config.regex) {
                var reg = new RegExp(config.regex);
                return reg.test(value);
            }

            return false;

        },
        isTaxIdentifier: function () {
            var value = arguments[0];
            return LhApp.Function.validateTaxIdentifier(true, 'GR', value);

        },

        isSocialSecurityNumber: function (value, parameters) {
            if (value.length === 0)
                return true;

            var isEleven = /^[0-9]{11}$/.test(value);
            var totalX = 0;
            for (var i = 0; i < 10; i++) {
                totalX += Number(value.substr(i, 1));
            }
            var isRuleX = totalX % 10 == value.substr(10, 1);
            var totalY1 = 0;
            var totalY2 = 0;
            for (var i = 0; i < 10; i += 2) {
                totalY1 += Number(value.substr(i, 1));
            }
            for (var i = 1; i < 10; i += 2) {
                totalY2 += Number(value.substr(i, 1));
            }
            var isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9, 0);
            var isRuleFirstDigit = value.substr(0, 1) != '0';

            return isEleven && isRuleX && isRuleY && isRuleFirstDigit;
        },

        isGreekTaxIdentifier: function (taxIdentifier) {

            if (taxIdentifier.length === 0)
                return true;

            if (!isNaN(parseInt(taxIdentifier)) && taxIdentifier.length === 9) {
                var result = 0;
                var arrTaxId = taxIdentifier.split("").map(function (item) {
                    return parseInt(item);
                });

                for (var i = arrTaxId.length - 2; i >= 0; i--) {
                    result = result + arrTaxId[i] * Math.pow(2, (8 - i));
                }

                if ((result % 11) % 10 === arrTaxId[8]) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }

        },

        isPhoneNumber: function (value) {
            if (value.length === 0)
                return true;

            var reg = /^\+?\d{10,14}$/;

            return reg.test(value);
        },

        isGreekPhone: function (value) {
            if (value.length === 0)
                return true;

            var reg = /^2[0-9]{9}$/;

            return reg.test(value);
        },

        isGreekMobile: function (value) {
            if (value.length === 0)
                return true;

            var reg = /^69[0-9]{8}$/;

            return reg.test(value);
        },

        isValidPhoneLocalized: function (value, paremeters, elem) {
            if (value.length === 0)
                return true;

            var iti = window.intlTelInputGlobals.getInstance(elem);
            var type = paremeters.type;
            var numberType = iti.getNumberType();
            var numberTypeIsValid = false;

            var regex = /^\+{0,1}[0-9]+$/g;

            if (type == "phone") {
                numberTypeIsValid = (numberType === intlTelInputUtils.numberType.FIXED_LINE || numberType === intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE) ? true : false;
            } else if (type == "mobile") {
                numberTypeIsValid = (numberType === intlTelInputUtils.numberType.MOBILE || numberType === intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE) ? true : false;
            } else if (type == "both") {
                numberTypeIsValid = (numberType === intlTelInputUtils.numberType.FIXED_LINE || numberType === intlTelInputUtils.numberType.MOBILE || numberType === intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE) ? true : false;
            }

            return iti.isValidNumber() && numberTypeIsValid && regex.test(value);
        },

        isValidPostalCode: function () {
            var value = arguments[0], config = arguments[1], digits;

            switch (config.country) {
                case 'GR':
                    digits = 5
                    break;
                case 'CY':
                    digits = 4
                    break;
                case 'CL':
                    digits = 7
                    break;
                case 'HU':
                    digits = 4
                    break;
            }

            if (!digits) return true;

            if (value.length === digits && config.areas.length > 0) {
                return true;
            } else if (value.length < 1) {
                return true;
            } else {
                return false;
            }
        }

    };

})(jQuery);
